import React from 'react'
// eslint-disable-next-line import/named
import { ToastContainer, ToastContainerProps, cssTransition } from 'react-toastify'

import { Box } from '@mui/material'

import 'react-toastify/dist/ReactToastify.css'

import { toastStyles } from './styles'

/** Появление сверху вниз для position top-right (без горизонтального Slide). */
const toastSlideDown = cssTransition({
  enter: 'Toastify__toast-slide-down-enter',
  exit: 'Toastify__toast-slide-down-exit',
  appendPosition: true,
  collapse: true,
  collapseDuration: 280,
})

export const Toast: React.FC<ToastContainerProps> = (props) => (
  <Box sx={toastStyles}>
    <ToastContainer
      transition={toastSlideDown}
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover={false}
      {...props}
    />
  </Box>
)
